import { ref, computed } from "vue";
import { defineStore } from "pinia";
import { InstitutionModel } from "@/app/institution/models/InstitutionModel";

export const useInstitution = defineStore(
  "institution",
  () => {
    const institutionId = ref(null);
    const institutions = ref([]);

    const currentInstitution = computed(() => {
      if (institutionId.value === null || institutionId.value === undefined || !institutions.value)
        return null;
      return (
        institutions.value.find(
          (item: InstitutionModel) =>
            item.id === institutionId.value || Number(item.id) === Number(institutionId.value),
        ) || null
      );
    });

    function setInstitutionId(value: number) {
      institutionId.value = value;
    }

    function setInstitutions(value: InstitutionModel[]) {
      institutions.value = value;
    }

    function clearInstitution() {
      institutionId.value = null;
      institutions.value = [];
    }

    return {
      institutionId,
      setInstitutionId,
      institutions,
      setInstitutions,
      currentInstitution,
      clearInstitution,
    };
  },
  {
    persist: {
      storage: sessionStorage,
    },
  },
);
